import styles from './ZeroResults.less';

import React, { Component } from 'react';

export default class ZeroResults extends Component {

  render() {
    return (
      <div className={styles.root} data-automation="searchZeroResults">
        <p className={styles.heading}>
          Sorry, we couldn't find anything. Maybe try taking the following steps&hellip;
        </p>
        <ul className={styles.ul}>
          <li className={styles.li}>
            Change or remove filters such as classification to broaden your search.
          </li>
          <li className={styles.li}>
            If using keywords, check the spelling.
          </li>
        </ul>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/ZeroResults/ZeroResults.js
 **/